<!--
 * @Author: your name
 * @Date: 2021-07-08 09:48:58
 * @LastEditTime: 2021-09-08 10:57:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\components\templates\bannerUnit.vue
-->
 
<template>

  <div class="banner-content" >
    <div :class="{'content-border':showBorder}">
        <el-carousel height="470px" v-if="bannerList.length>0">
            <el-carousel-item  v-for="item in bannerList" :key="item.id" >
                    <el-image  style="width: 100%; height: 100%" :src="item.imgUrl"  fit="fill"></el-image>
            </el-carousel-item>
        </el-carousel> 
    <el-carousel height="470px" v-else>
        <el-carousel-item  v-for="item in defaultBannerList" :key="item.id" >
                <el-image  style="width: 100%; height: 100%" :src="item.imgUrl"  fit="fill"></el-image>
        </el-carousel-item>
    </el-carousel>
    </div>
  </div>
</template>

<script>
import {defaultData} from './data/defaultData'
export default {
    props:{
        activeName: {
            type: String,
            default: ''
        },
        bannerList: {
          type: Array,
          default: function () {
             return []
          },
          
        },
    },
    data(){
        return {
            defaultBannerList:defaultData.bannerList,
            
        }
    },
    computed: {
        showBorder(){
            return  this.activeName=='banner'?true:false
         
        }
  },

}
</script>

<style lang="scss" scoped>
.banner-content{
    width: 1200px;
    position: relative;
}
.content-border:after{
    content: "";
    position: absolute;
    left: 0px;
    bottom:0;
    top:0;
    right:0;
    border:2px dashed red;  
    z-index: 50;
}
</style>
